import customAxios from "../../customAxios";
import { PAY_ADMIN_DEBT_FACTORS } from "../../routes";

type Props = {
  userId?: string;
};

const payDebtByAdmin = async (props: Props) => {
  var thisUrl = PAY_ADMIN_DEBT_FACTORS + "/" + props.userId;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ ADMIN_ALL_SERVICE: error });
  }
};

export default payDebtByAdmin;
